export function scrollToSection(sectionId: string) {
  const element = document.getElementById(sectionId);
  if (!element) return false;
  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}

export function requestHomeSection(sectionId: string, navigate: (path: string) => void) {
  if (window.location.pathname === '/') {
    window.setTimeout(() => scrollToSection(sectionId), 50);
    return;
  }
  navigate(`/?scroll=${encodeURIComponent(sectionId)}`);
}
